import { render } from "./PdfGenerationManual.vue?vue&type=template&id=940ed4d4&scoped=true"
import script from "./PdfGenerationManual.vue?vue&type=script&lang=js"
export * from "./PdfGenerationManual.vue?vue&type=script&lang=js"

import "./PdfGenerationManual.vue?vue&type=style&index=0&id=940ed4d4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940ed4d4"]])

export default __exports__